module.exports = __webpack_public_path__ + "img/portfolio-08.5dee8713.jpg";